import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Track page load time to detect unexpected reloads
console.log('[INDEX] 🔄 App loaded at:', new Date().toLocaleTimeString());
const loadTime = Date.now();
window.addEventListener('beforeunload', () => {
  const runTime = Math.round((Date.now() - loadTime) / 1000);
  console.log('[INDEX] ⚠️ Page unloading after', runTime, 'seconds');
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
